import { Link } from 'wouter'
import { useQuery } from '@apollo/client'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'
import { Trans } from '@lingui/react/macro'

import { FeedbackReadInfo } from './FeedbackReadInfo'

export function FeedbackTile({
  item
}: {
  item: GraphQL.SimpleFeedbackFragmentFragment
}) {
  const { data: goodieData } = useQuery(AdminAPI.goodie.GET, {
    variables: { id: item.goodieId ?? -1 },
    skip: !item.goodieId
  })

  const stay = getFragment(SharedAPI.stay.STAY_FRAGMENT, item.stay)
  const space = getFragment(SharedAPI.space.SPACE_FRAGMENT, stay?.space)

  const goodie = getFragment(
    SharedAPI.goodie.GOODIE_FRAGMENT,
    goodieData?.getGoodie
  )

  return (
    <article
      key={item.id}
      className="flex flex-row gap-4 bg-white rounded-medium px-4 py-6"
    >
      {space && (
        <div className="flex flex-row justify-center items-center">
          <span className="text-text-light text-heading2">
            {space?.identifier}
          </span>
        </div>
      )}
      <div className="flex flex-col gap-2.5 flex-1">
        {goodie && (
          <div className="flex flex-col">
            <h3 className="text-regular text-text-light">
              <Trans>Goodie</Trans>
            </h3>
            <Link className="text-info-500" to={`/goodie/${goodie.token}`}>
              {goodie.name}
            </Link>
          </div>
        )}
        <div className="flex flex-col">
          <h3 className="text-regular text-text-light">
            <Trans>Message</Trans>
          </h3>
          <span>{item.message}</span>
        </div>
      </div>
      <FeedbackReadInfo item={item} />
    </article>
  )
}
